import * as actions from './actions';
import * as getters from './getters';
import {FETCH_GALLERY_LIST } from '../../mutation-types';


const mutations = {
  [FETCH_GALLERY_LIST](state, payload) {
    state.galleryList = payload
  },
};

const state = {
  galleryList: null,
  url: '/v1/images'
};

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state,
};
